import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { Mapa } from '../pages/mapa/mapa';
import { DetallCarrer } from '../pages/detallCarrer/detallCarrer';
import { Llista } from '../pages/llista/llista';
import { Favorits } from './../pages/favorits/favorits';
import { Credits } from './../pages/credits/credits';

import { ModalShare } from './../components/modal-share/modal-share';
import { LupaComponent } from './../components/lupa/lupa';
import { ToolbarComponent } from './../components/toolbar/toolbar';
import { FiltresComponent } from './../components/filtres/filtres';
import { CarrerComponent } from './../components/carrer/carrer';
import { CarrerLlistaComponent } from './../components/carrer-llista/carrer-llista';
import { CarrerFavoritsComponent } from './../components/carrer-favorits/carrer-favorits';

import { FilterState } from './../providers/filter_state';
import { LocationProvider } from './../providers/locationProvider';
import { State } from './../providers/state';
import { AgmCoreModule, MapsAPILoader, NoOpMapsAPILoader, GoogleMapsAPIWrapper} from 'angular2-google-maps/core'
import { CustomMapDirective } from './arcgislink';

import { DirectionsMapDirective } from './../map/google-map.directive';

@NgModule({
  declarations: [
    MyApp,
    Mapa,
    DetallCarrer,
    LupaComponent,
    ToolbarComponent,
    FiltresComponent,
    CarrerComponent,
    Llista,
    CarrerLlistaComponent,
    CustomMapDirective,
    Favorits,
    CarrerFavoritsComponent,
    ModalShare,
    DirectionsMapDirective,
    Credits
  ],
  imports: [
    IonicModule.forRoot(MyApp, {}, {
     links: [
      { component: DetallCarrer, name: 'DetallCarrer', segment: 'detall/:OBJECTID', defaultHistory: [Mapa] }
    ]
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAXxhq-k3z61yy9JiaKJWCKRpob9NvCuJE'
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    Mapa,
    DetallCarrer,
    LupaComponent,
    ToolbarComponent,
    FiltresComponent,
    CarrerComponent,
    Llista,
    CarrerLlistaComponent,
    Favorits,
    CarrerFavoritsComponent,
    ModalShare,
    Credits
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: MapsAPILoader, useClass: NoOpMapsAPILoader},
    LocationProvider,
    State,
    GoogleMapsAPIWrapper,
    FilterState
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts